import React from 'react';
import { Page as Component } from '~/components/specifics/settings/company_vendors/Page';

export const Page: React.FC = () => <Component />;
